import React from 'react';
import BreadcrumbBanner from './BreadcrumbBanner';
import CTASection from './CTASection';
function Services() {
  // नया फीचर सेक्शन डेटा (इमेज जैसा)
  const features = [
    { icon: "fa-heart", title: "Passion", desc: "", color: "bg-danger" },
    { icon: "fa-lightbulb", title: "Innovation", desc: ".", color: "bg-warning" },
    { icon: "fa-shield-alt", title: "Integrity", desc: "", color: "bg-success" },
    { icon: "fa-users", title: "Teamwork", desc: "", color: "bg-primary" }
  ];

  return (
    <div>
      <BreadcrumbBanner title="Our Services" />

      {/* Feature Section (इमेज जैसा डिज़ाइन) */}
      <section className="py-5">
        <div className="container">
          <div className="row">
            {features.map((item, index) => (
              <div key={index} className="col-md-3 mb-4">
                <div className="card h-100 border-0 shadow-sm p-4 text-center rounded-4">
                  <div className={`mx-auto mb-3 p-3 text-white rounded-3 ${item.color}`} style={{ width: "60px", height: "60px" }}>
                    <i className={`fas ${item.icon} fa-lg`}></i>
                  </div>
                  <h5 className="fw-bold">{item.title}</h5>
                  <p className="text-muted small">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="bg-light py-5">
        <div className="container">
          <h2 className="text-primary fw-bold text-center mb-5">Professional Repair Services</h2>
          <div className="row">
            {[ 
              { title: "Office Chair Repair", img: "/images/service1.jpg", desc: "Install new caster wheels." },
              { title: "Mesh Chair Repair", img: "/images/service2.jpg", desc: "Repair damaged mesh backs." },
              { title: "Recliner Mechanism", img: "/images/service3.jpg", desc: "Fix reclining systems." },
              { title: "Computer Chair", img: "/images/service4.jpg", desc: "Affordable repairs." },
              { title: "Gaming Chair", img: "/images/service5.jpg", desc: "Repair hydraulics and wheels." },
              { title: "Seat Cushion", img: "/images/service6.jpg", desc: "Replace damaged foam." }
            ].map((service, index) => (
              <div key={index} className="col-md-4 mb-4">
                <div className="card h-100 border-0 shadow">
                  <img src={service.img} className="card-img-top" alt={service.title} />
                  <div className="card-body">
                    <h5 className="card-title">{service.title}</h5>
                    <p className="card-text">{service.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

        </div>
      </section>
       <CTASection />
    </div>
  );
}

export default Services;